export default __webpack_public_path__ + "01905d39a5c968e8bc0c93c1c9426b87.png";